<template>
  <div class="each-user-wrap">
    <div class="info-wrap">
      <div class="info">
        <span>{{$t('register.name')}}: {{user.usr_firstname}}</span>
        <span>{{$t('register.lastName')}}: {{user.usr_lastname}}</span>
        <span>{{$t('register.email')}}: {{user.usr_email}}</span>
        <span>{{$t('adminApproval.licenceNumber')}}: {{user.licence}}</span>
      </div>
    </div>
    <div class="buttons">
      <div class="buttons-line">
        <button v-if="view" class="approve-btn" @click="emitActionAndUsrId('validate')">{{$t('button.validate')}}</button>
        <button class="reject-btn" v-if="view === 'pendingApproval'" @click="emitActionAndUsrId('reject')">{{$t('button.reject')}}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    props: {
      user: Object,
      view: String
    },
    methods: {
      emitActionAndUsrId (action) {
        this.$emit('set-user-id', this.user.usr_id);
        this.$emit(action);
      }
    }
}
</script>

<style scoped>
    * {
        box-sizing: border-box;
    }
    .each-user-wrap {
        display: flex;
        flex-direction: row;
        min-height: 125px;
    }
    .info-wrap {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 50%;
    }
    .info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    .info span {
        display: inline-block;
        margin: 0.5%;
    }
    .buttons {
        display: flex;
        align-items: center;
        width: 50%;
    }
    .buttons-line {
        display: flex;
        justify-content: space-evenly;
        width: 100%;
    }
    .buttons-line button {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        white-space: nowrap;
        border: none;
        padding: 2% 4%;
        font-size: 1em;
        box-shadow: 0px 0px 250px rgba(0, 0, 0, 0.25);
        border-radius: 100px;
        font-size: 13px;
        color: white;
    }
    .buttons-line button:focus {
        border: none;
        outline: none;
    }
    .approve-btn {
        background-color: var(--button-color-blue);
    }
    .reject-btn {
        background-color: var(--button-color-bright-red);
    }
</style>